import { useMemo } from 'react'

const FeeStatusTag = ({ text, color }) => {
	const bg = useMemo(() => {
		let bgGolor = color?.slice(1) || '#ffffff'
		var aRgbHex = bgGolor.match(/.{1,2}/g)
		var aRgb = [parseInt(aRgbHex[0], 16), parseInt(aRgbHex[1], 16), parseInt(aRgbHex[2], 16)]
		return `rgba(${aRgb[0]}, ${aRgb[1]}, ${aRgb[2]}, 0.2)`
	}, [color])

	return (
		<div className="c-fee__status__tag">
			<span className="fee__status__tag-text" style={{ color, backgroundColor: bg }}>
				{text || "Không có dữ liệu"}
			</span>
		</div>
	)
}

export default FeeStatusTag
